import { tw } from "@/utils";
import TestProfile from "./testChattingProfileImage.png";
import dayjs from "dayjs";

import { TypographyIcon, FileIcon, SendIcon } from "./assets";

interface ChattingProps {
  // props 정의
}

export const Chatting = (props: ChattingProps) => {
  const {} = props;

  return (
    <div className="w-full h-full p-[20px] bg-white">
      {/* header */}
      <div className="flex gap-[12px]">
        <img
          src={TestProfile}
          className={tw(
            "w-[44px] h-[44px] object-cover rounded-full",
            "border-solid border-[0.5px] border-gray-g75"
          )}
        />
        <div>
          <div className="leading-[24px] text-base font-semibold text-gray-g300">
            순환기내과 / 박무강
          </div>
          <div className="flex items-center gap-[6px]">
            <div className="w-[8px] aspect-square rounded-full bg-purple-100"></div>
            <div className="leading-[20px] text-sm font-semibold text-purple-100">
              Online
            </div>
          </div>
        </div>
      </div>
      <div className="w-full h-[1px] bg-gray-g30 my-[20px]"></div>
      {/* 채팅 본문 */}
      <div className="w-full h-[calc(100%-213px)] flex flex-col gap-[24px] overflow-auto pb-[10px]">
        <ChattingContent
          isMe
          author="김지선"
          specialty="응급의학과"
          text="발생한 지 40분 경과했고 여전히 7/10 통증 호소 중입니다. Nitroglycerin
        1회 투여, 반응 경미합니다."
          time="2025-04-21 09:12"
        />
        <ChattingContent
          author="박무강"
          specialty="순환기내과"
          text="BP 유지 모니터링 부탁드리고 Chest X-ray는 가능하면 전송 부탁드립니다."
          time="2025-04-21 09:13"
        />
      </div>
      <div className="relative w-full h-[128px]">
        <textarea
          className={tw(
            "w-full h-[128px] p-[10px] resize-none pb-[40px]",
            "border-solid border-[1px] border-gray-g50 rounded-[12px]"
          )}
        />
        <div className="absolute bottom-[10px] flex items-center justify-between w-[calc(100%-20px)] h-[28px] bg-white z-10 ml-[10px] mr-[30px]">
          <div className="flex items-center gap-[12px]">
            <TypographyIcon />
            <FileIcon />
          </div>
          <button
            className="flex items-center justify-center w-[28px] aspect-square rounded-[7px] bg-gray-g30"
            onClick={() => {
              window.alert("준비 중입니다.");
            }}
          >
            <SendIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

const ChattingContent = (props: {
  isMe?: boolean;
  author: string;
  specialty: string;
  text: string;
  time: string;
}) => {
  const { isMe, author, specialty, text, time } = props;

  return (
    <div
      className={tw(
        "flex flex-col gap-[8px] w-[71%] max-w-[440px] h-fit rounded-[14px] p-[16px] bg-gray-g10",
        isMe && "bg-purple-30 ml-auto"
      )}
    >
      <div
        className={tw(
          "text-sm font-semibold",
          isMe ? "text-purple-100" : "text-gray-g200"
        )}
      >
        {`${isMe ? "나" : author} / ${specialty}`}
      </div>
      <div className="text-sm font-medium text-gray-g400 leading-[18px] mb-[10px]">
        {text}
      </div>
      <div className="flex gap-[10px] ml-auto">
        <div className="text-sm font-regular text-gray-g75">
          {dayjs(time).format("A hh:mm")}
        </div>
      </div>
    </div>
  );
};
